import defineProperty from "./_defineProperty.js";
function baseAssignValue(object, key, value) {
  key == "__proto__" && defineProperty ? defineProperty(object, key, {
    configurable: !0,
    enumerable: !0,
    value,
    writable: !0
  }) : object[key] = value;
}
export {
  baseAssignValue as default
};
//# sourceMappingURL=_baseAssignValue.js.map
